import { Link } from "@shapr3d/frontend-lib";
import type { ReactNode } from "react";

import { zendeskNewTicketUrl } from "../../config";
import { urlWithZendeskAuth } from "../../urlUtils";

export const NewZendeskTicketLink: React.FC<{ children: ReactNode }> = ({ children, ...props }) => {
  return (
    <Link href={urlWithZendeskAuth(zendeskNewTicketUrl)} {...props}>
      {children}
    </Link>
  );
};
